import { render } from "./BenefitsTopic.vue?vue&type=template&id=5f8dbc2a&ts=true"
import script from "./BenefitsTopic.vue?vue&type=script&lang=ts"
export * from "./BenefitsTopic.vue?vue&type=script&lang=ts"

import "./BenefitsTopic.vue?vue&type=style&index=0&id=5f8dbc2a&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__